import { css } from 'styled-components';
import { bindTombac } from '../tombac';
function propToCssValue(tombac, attrName, propValue) {
  if (typeof propValue === 'number' || Array.isArray(propValue)) {
    // For compatibility with the old layoutStyles.
    return compatPropToCssValue(tombac, attrName, propValue);
  }
  if (typeof propValue === 'string') {
    return tombac.parse(propValue);
  }
  return propValue;
}
function compatPropToCssValue(tombac, attrName, propValue) {
  if (typeof propValue === 'number' && ['height', 'gap', 'margin', 'padding', 'width'].find(i => attrName.toLowerCase().includes(i.toLowerCase()))) {
    return tombac.space(propValue);
  }
  if (Array.isArray(propValue)) {
    return tombac.space(...propValue);
  }
  return propValue === null || propValue === void 0 ? void 0 : propValue.toString();
}
export const createPropStyling = (cssAttrNames, aliases) => {
  return css(["", ""], _ref => {
    let {
      theme,
      ...props
    } = _ref;
    const tombac = bindTombac(theme);
    const result = {};
    for (let propName in props) {
      let attrName = propName.replace('$', '');
      if (aliases !== null && aliases !== void 0 && aliases.hasOwnProperty(attrName)) {
        attrName = aliases[attrName];
      }
      if (cssAttrNames.includes(attrName)) {
        const propValue = props[propName];
        result[attrName] = propToCssValue(tombac, attrName, propValue);
      }
    }
    return result;
  });
};
//# sourceMappingURL=privatePropStylingUtils.js.map